module.exports = __webpack_public_path__ + "img/A1-5-plan.389b9801.png";